"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.packCardsNormalizer = void 0;
const mocks_json_1 = __importDefault(require("./mocks.json"));
const utils_common_to_kebap_case_1 = __importDefault(require("@gcloud-npm/utils.common.to-kebap-case"));
const extractProductChannels = (children, channelsOrder) => {
    var _a;
    const result = {};
    if (Object.keys(children).length === 0) {
        return null;
    }
    for (const key in children) {
        if (children.hasOwnProperty(key)) {
            const { categories, data } = children[key];
            const categorie = categories[0] || null;
            const icono = ((_a = data.fields) === null || _a === void 0 ? void 0 : _a.icono) || null;
            result[key] = {
                categorie,
                image: {
                    src: icono,
                    width: 143,
                    height: 99,
                },
            };
        }
    }
    if (channelsOrder.length > 1) {
        const orderedResult = {};
        channelsOrder.forEach((channel) => {
            orderedResult[channel] = result[channel];
        });
        return orderedResult;
    }
    return result;
};
const extractLongCharacteristicsList = (listCharacs) => {
    if (!listCharacs) {
        return null;
    }
    let result = [];
    listCharacs.map((charac) => {
        const { fields } = charac;
        const { characteristics } = fields;
        let normalizedCharacteristics = {};
        const newArrayCharacteristics = characteristics.map((item) => ({
            title: Object.assign(Object.assign({}, mocks_json_1.default["FlyOut-1"]["Text-5"]), { text: item.fields.title }),
            bullets: item.fields.description,
        }));
        normalizedCharacteristics = {
            icon: fields === null || fields === void 0 ? void 0 : fields.icon,
            title: Object.assign(Object.assign({}, mocks_json_1.default["FlyOut-1"]["Text-4"]), { text: fields === null || fields === void 0 ? void 0 : fields.title }),
            subcaracteristicas: newArrayCharacteristics,
        };
        result.push(normalizedCharacteristics);
    });
    return result;
};
const extractShortCharacteristicsList = (listCharacs) => {
    if (!listCharacs || Object.keys(listCharacs).length === 0) {
        return null;
    }
    const { fields } = listCharacs;
    const { listadoCaracteristicas } = fields;
    const newArrayCharacteristics = listadoCaracteristicas.map((item) => {
        // conversión de iconos que algun dia si se contribuye bien desde orion, se quitará
        if (item.fields.icon === "Desco") {
            item.fields.icon = "descouhd";
        }
        if (item.fields.icon === "MultiDispositivo") {
            item.fields.icon = "multidispositivos";
        }
        return {
            icon: (0, utils_common_to_kebap_case_1.default)(item.fields.icon.toLowerCase()),
            title: Object.assign(Object.assign({}, mocks_json_1.default["FlyOut-1"]["Text-9"]), { text: item.fields.title }),
            description: Object.assign(Object.assign({}, mocks_json_1.default["FlyOut-1"]["Text-10"]), { text: item.fields.description }),
        };
    });
    const result = {
        title: Object.assign(Object.assign({}, mocks_json_1.default["FlyOut-1"]["Text-8"]), { text: fields === null || fields === void 0 ? void 0 : fields.title }),
        characteristics: newArrayCharacteristics,
    };
    return result;
};
const extractProductOffer = (offer) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const res = {};
    const { data: offerData } = offer;
    res.price = offer.price || null;
    res.promoId = offer.promoId || null;
    res.bandaPromo = ((_a = offerData === null || offerData === void 0 ? void 0 : offerData.fields) === null || _a === void 0 ? void 0 : _a.bandaPromo) || null;
    res.bandaInfo = ((_b = offerData === null || offerData === void 0 ? void 0 : offerData.fields) === null || _b === void 0 ? void 0 : _b.bandaInfo) || null;
    res.claimPromo = ((_c = offerData === null || offerData === void 0 ? void 0 : offerData.fields) === null || _c === void 0 ? void 0 : _c.claimPromo) || null;
    res.titleLegal = ((_d = offerData === null || offerData === void 0 ? void 0 : offerData.fields) === null || _d === void 0 ? void 0 : _d.titleLegalcorto) || null;
    res.ctz_claimPrincipal_promo =
        ((_e = offerData === null || offerData === void 0 ? void 0 : offerData.fields) === null || _e === void 0 ? void 0 : _e.ctz_claimPrincipal_promo) || null;
    res.topDescription = ((_f = offerData === null || offerData === void 0 ? void 0 : offerData.fields) === null || _f === void 0 ? void 0 : _f.topDescription) || null;
    res.legal = ((_g = offerData === null || offerData === void 0 ? void 0 : offerData.fields) === null || _g === void 0 ? void 0 : _g.legalCorto) || null;
    res.legalCorto = offer.legal || null;
    res.upDescriptionOffer = ((_h = offerData === null || offerData === void 0 ? void 0 : offerData.fields) === null || _h === void 0 ? void 0 : _h.upDescription) || null;
    return res;
};
const extractProductInfoItem = (product) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    if (!product) {
        return null;
    }
    const res = {
        name: product.name,
        alias: product.alias,
        baseOffer: {},
        offer: {},
        channels: {},
        productName: (_a = product.productTaxonomy) === null || _a === void 0 ? void 0 : _a.prodName,
    };
    const { data, baseOffer, offers, children, upDescription, categories } = product;
    if (upDescription) {
        res.upDescription = { text: upDescription };
    }
    if (baseOffer) {
        res.baseOffer = extractProductOffer(baseOffer);
    }
    if (data) {
        const { fields } = data;
        let productoGPBAF = null;
        let productDetail = null;
        let cardsChars = null;
        productoGPBAF = fields === null || fields === void 0 ? void 0 : fields["DATAMAP_TV"];
        cardsChars = fields === null || fields === void 0 ? void 0 : fields["CARACTERISTICAS_CARD"];
        productDetail = fields === null || fields === void 0 ? void 0 : fields["CARACTERISTICAS_FICHA"];
        if (productoGPBAF) {
            const { fields } = productoGPBAF;
            res.currency = fields === null || fields === void 0 ? void 0 : fields.unidad;
            res.urlProdCompra = fields === null || fields === void 0 ? void 0 : fields.urlProdCompra;
            res.isRecom = fields === null || fields === void 0 ? void 0 : fields.isRecom;
            res.urlFicha = fields === null || fields === void 0 ? void 0 : fields.urlFicha;
            res.nombreComercial = fields === null || fields === void 0 ? void 0 : fields.nombreComercial;
            res.imageCard = fields === null || fields === void 0 ? void 0 : fields.imgDesktop;
            res.imageFlyOut = fields === null || fields === void 0 ? void 0 : fields.imgDeskFicha;
            res.productDespription = fields === null || fields === void 0 ? void 0 : fields.ctz_claimPrincipal;
            res.textRecommended = fields === null || fields === void 0 ? void 0 : fields.textRecommended;
            res.targetUrl = fields === null || fields === void 0 ? void 0 : fields.target;
            res.textPrice = fields === null || fields === void 0 ? void 0 : fields.textPrice;
            if (children) {
                res.channels = extractProductChannels(children, fields === null || fields === void 0 ? void 0 : fields.channelsOrder);
            }
        }
        if (cardsChars) {
            const cardCharList = (_b = cardsChars === null || cardsChars === void 0 ? void 0 : cardsChars.fields) === null || _b === void 0 ? void 0 : _b["LISTADO_CARACTERISTICAS_CARD"];
            const cardCharListFlyout = (_c = cardsChars === null || cardsChars === void 0 ? void 0 : cardsChars.fields) === null || _c === void 0 ? void 0 : _c["LISTADO_CARACTERISTICAS_FLYOUT"];
            if (Array.isArray(cardCharList) && cardCharList[0]) {
                const characteristics = cardCharList[0];
                let paragraph = (_d = characteristics === null || characteristics === void 0 ? void 0 : characteristics.fields) === null || _d === void 0 ? void 0 : _d.characteristics;
                paragraph.forEach((e, i) => (paragraph[i] = `• ${e}`));
                res.subTitle = (_e = characteristics === null || characteristics === void 0 ? void 0 : characteristics.fields) === null || _e === void 0 ? void 0 : _e.title;
                res.icon = (_f = characteristics === null || characteristics === void 0 ? void 0 : characteristics.fields) === null || _f === void 0 ? void 0 : _f.icon;
                res.imagen = (_g = characteristics === null || characteristics === void 0 ? void 0 : characteristics.fields) === null || _g === void 0 ? void 0 : _g.img;
                if (Array.isArray(paragraph)) {
                    res.paragraph = paragraph.join("<br/>");
                }
            }
            if (cardCharListFlyout) {
                if (Array.isArray(cardCharListFlyout) && cardCharListFlyout[0]) {
                    const characteristicsFlyout = cardCharListFlyout[0];
                    const objectCharacsFlyOut = {};
                    objectCharacsFlyOut.characs =
                        (_h = characteristicsFlyout === null || characteristicsFlyout === void 0 ? void 0 : characteristicsFlyout.fields) === null || _h === void 0 ? void 0 : _h.characteristics;
                    objectCharacsFlyOut.subTitle = (_j = characteristicsFlyout === null || characteristicsFlyout === void 0 ? void 0 : characteristicsFlyout.fields) === null || _j === void 0 ? void 0 : _j.title;
                    objectCharacsFlyOut.icon = (_k = characteristicsFlyout === null || characteristicsFlyout === void 0 ? void 0 : characteristicsFlyout.fields) === null || _k === void 0 ? void 0 : _k.icon;
                    objectCharacsFlyOut.imagen = (_l = characteristicsFlyout === null || characteristicsFlyout === void 0 ? void 0 : characteristicsFlyout.fields) === null || _l === void 0 ? void 0 : _l.img;
                    objectCharacsFlyOut.urlIframe = (_m = characteristicsFlyout === null || characteristicsFlyout === void 0 ? void 0 : characteristicsFlyout.fields) === null || _m === void 0 ? void 0 : _m.urlIframe;
                    res.characsFlyOut = objectCharacsFlyOut;
                }
            }
        }
        if (productDetail) {
            const { fields } = productDetail[0];
            res.shortCharacteristicsList = extractShortCharacteristicsList(fields === null || fields === void 0 ? void 0 : fields["LISTADO_CARACTERISTICAS_FICHA_CORTAS"]);
            res.longCharacteristicsList = extractLongCharacteristicsList(fields === null || fields === void 0 ? void 0 : fields["LISTADO_CARACTERISTICAS_FICHA_LARGAS"]);
        }
    }
    if (offers && Object.keys(offers).length > 0) {
        Object.keys(offers).map((offer) => {
            const oferta = offers[offer];
            const ofertaRes = extractProductOffer(oferta);
            res.offer = ofertaRes;
        });
    }
    if (categories) {
        res.categories = categories;
    }
    return res;
};
const extractProductInfo = (product, extra_info) => {
    if (Array.isArray(product)) {
        return product.map((productItem) => extractProductInfoItem(productItem, extra_info));
    }
    else {
        return extractProductInfoItem(product, extra_info);
    }
};
const normalizeOrionStructureItem = (product, extra_info) => {
    var _a, _b;
    let res = null;
    if (product) {
        res = {};
        let offerInfo = product.baseOffer;
        let channelsInfo = product.channels;
        let isRecom = product.isRecom;
        let textRecommended = product.textRecommended;
        let nombreComercial = product.nombreComercial;
        let onClick = true;
        let currency = "";
        let quote = "";
        if (product.currency) {
            const currencySplit = product.currency.split("/");
            currency = currencySplit[0];
            quote = currencySplit[1] || "";
        }
        let price1 = { currency };
        let price2 = { price: offerInfo.price, currency, quote };
        if (product.productName || product.alias) {
            res.alias = product.productName || product.alias || "";
        }
        if (product.categories) {
            res.categories = product.categories;
        }
        if (product.imageCard) {
            res["Image-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Image-1"]), { src: "https://prod.cms.col.movistar.es" + product.imageCard, 
                // srcWebp: "https://prod.cms.col.movistar.es" + product.imgSrcWebp,
                alt: nombreComercial || "", hash: global.hash || '' });
        }
        // miro si me quedo con los datos de oferta o baseoffer
        if (!!isRecom) {
            res["Label-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Label-1"]), { text: isRecom });
        }
        if (!!textRecommended) {
            res["Label-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Label-1"]), { text: textRecommended });
        }
        if (product.offer && Object.keys(product.offer).length > 0) {
            if ((offerInfo === null || offerInfo === void 0 ? void 0 : offerInfo.price) !== product.offer.price) {
                price1.price = offerInfo.price;
                price2 = Object.assign(Object.assign({}, price2), { price: product.offer.price, color: "red_dark" });
            }
            offerInfo = product.offer;
        }
        if (!!nombreComercial) {
            res["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), { text: nombreComercial });
        }
        if (product.icon) {
            res["Glyph-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Glyph-1"]), { id: (0, utils_common_to_kebap_case_1.default)(product.icon) });
        }
        if (product.imagen) {
            res["Image-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Image-2"]), { src: product.imagen, 
                // srcWebp: "https://prod.cms.col.movistar.es" + product.imgSrcWebp,
                alt: nombreComercial || "" });
        }
        if (product.paragraph) {
            res["Text-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-2"]), { text: product.paragraph });
        }
        if (offerInfo.claimPromo) {
            res["Text-3"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-3"]), { text: offerInfo.claimPromo, color: "red_dark" });
        }
        if (offerInfo.ctz_claimPrincipal_promo) {
            res["Text-3"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-3"]), { text: offerInfo.ctz_claimPrincipal_promo, color: "grey5" });
        }
        if (product.upDescription && product.upDescription.text) {
            res["Text-3"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-3"]), product.upDescription);
        }
        if (offerInfo === null || offerInfo === void 0 ? void 0 : offerInfo.upDescriptionOffer) {
            res["Text-3"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-3"]), { text: offerInfo.upDescriptionOffer });
        }
        if (offerInfo.topDescription && offerInfo.topDescription) {
            res["Text-4"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-4"]), { text: offerInfo.topDescription, color: "grey6" });
        }
        if (offerInfo.bandaInfo) {
            res["Text-4"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-4"]), { text: offerInfo.bandaInfo, color: "red_dark" });
        }
        if (offerInfo.bandaPromo) {
            res["Label-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Label-2"]), { label: offerInfo.bandaPromo });
        }
        if (price1 && price1.price) {
            res["Price-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Price-1"]), price1);
        }
        if (price2 && price2.price) {
            res["Price-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Price-2"]), price2);
        }
        if ((extra_info === null || extra_info === void 0 ? void 0 : extra_info.infoButtonOne) && (product === null || product === void 0 ? void 0 : product.urlProdCompra)) {
            res["Button-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Button-1"]), { label: (_a = extra_info === null || extra_info === void 0 ? void 0 : extra_info.infoButtonOne) === null || _a === void 0 ? void 0 : _a.label, href: product === null || product === void 0 ? void 0 : product.urlProdCompra });
        }
        if (onClick) {
            res["Button-3"] = Object.assign(Object.assign({}, mocks_json_1.default["Button-3"]), { label: "Ver detalle" });
            res["CustomLink-1"] = Object.assign(Object.assign({}, mocks_json_1.default["CustomLink-1"]), { href: "", title: nombreComercial || "" });
            res["FlyOut-1"] = {
                "Text-1": Object.assign(Object.assign({}, mocks_json_1.default["FlyOut-1"]["Text-1"]), { text: "" }),
                "Text-2": Object.assign(Object.assign({}, mocks_json_1.default["FlyOut-1"]["Text-2"]), { text: nombreComercial }),
                "Text-3": Object.assign(Object.assign({}, mocks_json_1.default["FlyOut-1"]["Text-3"]), { text: product === null || product === void 0 ? void 0 : product.productDespription }),
                "Text-6": Object.assign(Object.assign({}, mocks_json_1.default["FlyOut-1"]["Text-6"]), { text: product === null || product === void 0 ? void 0 : product.textPrice }),
                "Image-1": Object.assign(Object.assign({}, mocks_json_1.default["FlyOut-1"]["Image-1"]), { src: product === null || product === void 0 ? void 0 : product.imageFlyOut, hash: global.hash || '' }),
                "Price-1": Object.assign(Object.assign({}, mocks_json_1.default["FlyOut-1"]["Price-1"]), price1),
                "Channels-1": channelsInfo
                    ? { title: mocks_json_1.default["FlyOut-1"]["Text-14"], channelsInfo }
                    : null,
                "Characs-1": (product === null || product === void 0 ? void 0 : product.characsFlyOut) || {},
                "Features-1": (product === null || product === void 0 ? void 0 : product.longCharacteristicsList) || {},
                "Features-2": (product === null || product === void 0 ? void 0 : product.shortCharacteristicsList) || {},
                "TextLegal-1": Object.assign({}, mocks_json_1.default["FlyOut-1"]["Text-11"]),
                "TextLegal-2": Object.assign({}, mocks_json_1.default["FlyOut-1"]["Text-12"]),
                "urlIframe": ((_b = product === null || product === void 0 ? void 0 : product.characsFlyOut) === null || _b === void 0 ? void 0 : _b.urlIframe) || "",
            };
            if (price2 && price2.price) {
                res["FlyOut-1"]["Price-2"] = Object.assign(Object.assign({}, mocks_json_1.default["FlyOut-1"]["Price-2"]), price2);
            }
            if (offerInfo && offerInfo.legalCorto) {
                res["FlyOut-1"]["TextLegal-3"] = Object.assign(Object.assign({}, mocks_json_1.default["FlyOut-1"]["Text-13"]), { text: offerInfo.legalCorto });
            }
        }
    }
    return res;
};
const normalizeOrionStructure = (products, extra_info) => {
    if (Array.isArray(products)) {
        let productsObj = {};
        products.forEach((product, i) => (productsObj[`Product-${i + 1}`] = normalizeOrionStructureItem(product, extra_info)));
        return productsObj;
    }
    else {
        return {
            "Product-1": normalizeOrionStructureItem(products, extra_info),
        };
    }
};
/**
 * normalizador del modulo MODULO_BUYBOX
 * @param {object} fields
 * @returns
 */
const packCardsNormalizer = (data) => {
    var _a, _b, _c, _d, _e, _f;
    try {
        let res = {};
        const name = data === null || data === void 0 ? void 0 : data.name;
        const sectionTitle = { text: (_a = data === null || data === void 0 ? void 0 : data.fields) === null || _a === void 0 ? void 0 : _a.title };
        const configuraLink = (_c = (_b = data === null || data === void 0 ? void 0 : data.fields) === null || _b === void 0 ? void 0 : _b.lnk) === null || _c === void 0 ? void 0 : _c.fields;
        const extra_info = {
            infoButtonOne: (_e = (_d = data === null || data === void 0 ? void 0 : data.fields) === null || _d === void 0 ? void 0 : _d.lnk) === null || _e === void 0 ? void 0 : _e.fields,
        };
        const products = extractProductInfo((_f = data === null || data === void 0 ? void 0 : data.fields) === null || _f === void 0 ? void 0 : _f.products);
        if (products) {
            if (sectionTitle && sectionTitle.text) {
                res["Text-5"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-5"]), sectionTitle);
            }
            if (configuraLink && (configuraLink === null || configuraLink === void 0 ? void 0 : configuraLink.label) && (configuraLink === null || configuraLink === void 0 ? void 0 : configuraLink.href)) {
                if (name === "MODULO_PACK_CARD") {
                    res["ButtonDesk-1"] = Object.assign({}, configuraLink);
                }
                if (name === "MODULO_FILTER_CATEGORY") {
                    res["ButtonDesk-1"] = Object.assign({}, configuraLink);
                }
                if (name === "MODULO_SIMPLE_CARD") {
                    res["ButtonMobile-1"] = Object.assign({}, configuraLink);
                }
            }
            res["Pack-Cards"] = normalizeOrionStructure(products, extra_info);
        }
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.packCardsNormalizer = packCardsNormalizer;
exports.default = exports.packCardsNormalizer;
//# sourceMappingURL=index.js.map